import React from 'react';
import Resident from '@components/resident';
import { ResidentPageType } from '@typings/ResidentTypes';

const EditResident = () => {
  return <Resident type={ResidentPageType.EDIT} />;
};

export default EditResident;
